import { storefrontApiRequest, CART_CREATE_MUTATION, formatCheckoutUrl } from '@/lib/shopify';
import { trackStartedCheckout } from '@/lib/klaviyo';

interface BuyNowParams {
  variantId: string;
  quantity: number;
  productId: string;
  productName: string;
  productHandle: string;
  imageUrl: string;
  price: number;
  variantTitle: string;
  currencyCode: string;
}

/**
 * Creates a Shopify cart with a single item and returns the checkout URL.
 * Used for "Buy Now" direct checkout functionality.
 */
export async function createInstantCheckout(params: BuyNowParams): Promise<string | null> {
  try {
    const data = await storefrontApiRequest(CART_CREATE_MUTATION, {
      input: { lines: [{ quantity: params.quantity, merchandiseId: params.variantId }] },
    });

    if (data?.data?.cartCreate?.userErrors?.length > 0) {
      console.error('Instant checkout failed:', data.data.cartCreate.userErrors);
      return null;
    }

    const cart = data?.data?.cartCreate?.cart;
    if (!cart?.checkoutUrl) return null;

    const checkoutUrl = formatCheckoutUrl(cart.checkoutUrl);

    // Track Started Checkout in Klaviyo
    trackStartedCheckout({
      checkoutUrl,
      items: [{
        productId: params.productId,
        productName: params.productName,
        productUrl: `${window.location.origin}/product/${params.productHandle}`,
        imageUrl: params.imageUrl,
        price: params.price,
        quantity: params.quantity,
        variantId: params.variantId,
        variantTitle: params.variantTitle,
      }],
      currencyCode: params.currencyCode,
    });

    return checkoutUrl;
  } catch (error) {
    console.error('Failed to create instant checkout:', error);
    return null;
  }
}
